import { Grid } from '@material-ui/core';
import { LayoutConstants } from '../../../../theme/LayoutConstants';
import { TagForm } from '../../../../components/tag/form/TagForm';
import { useTagQuery } from '../../../../graphql/models';
import { useParams } from 'react-router-dom';
import { ApiRequestErrorAndLoadingWrapper } from '../../../../components/common/ApiRequestWrapper';
import { FormBreadCrumbs } from '../../../../components/common/navigation/breadcrumbs/FormBreadcrumbs';

export const EditTagPage = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const numberId = Number(id);

  const { data, error, loading } = useTagQuery({
    variables: { id: numberId },
  });

  return (
    <ApiRequestErrorAndLoadingWrapper error={error} loading={loading}>
      <Grid container spacing={LayoutConstants.gridSpacing}>
        <Grid item xs={12}>
          <FormBreadCrumbs />
        </Grid>
        <Grid item xs={12}>
          <TagForm tag={data?.tag} />
        </Grid>
      </Grid>
    </ApiRequestErrorAndLoadingWrapper>
  );
};
